import TextInput from '@/atoms/forms/Input/Text/Input';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { useTranslation } from 'react-i18next';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

type Props = {
  closeModal: () => void;
  currentName: string;
  onSubmit: (newName: string) => Promise<void>;
};

const schema = yup.object({
  name: yup.string().required().max(150),
});

type FormValues = {
  name: string;
};

const RenamePrintingPage = ({ closeModal, currentName, onSubmit }: Props) => {
  const { t } = useTranslation();

  const formMethods = useForm<FormValues>({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
    defaultValues: {
      name: currentName,
    },
  });

  const handleSubmit = async (data: FormValues) => {
    await onSubmit(data.name);
    closeModal();
  };

  return (
    <ModalClassicLayout
      closeModal={closeModal}
      isSubmitDisabled={formMethods.formState.isSubmitting}
      onSubmit={formMethods.handleSubmit(handleSubmit)}
      submitLabel={t('rename')}
      title={t('rename-page')}
    >
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(handleSubmit)}>
          <div className="flex flex-col gap-4">
            <TextInput label={t('page-name')} name="name" placeholder={t('enter-page-name')} />
          </div>
          <input className="hidden" type="submit" />
        </form>
      </FormProvider>
    </ModalClassicLayout>
  );
};

export default RenamePrintingPage;
